<script>
export default {
    name: "VTextFieldPassword",
    inheritAttrs: false,
    props: {
        value: {},
    },
    data() {
        return {
            isVisiblePassword: false,
        };
    },
}
</script>

<template>
    <v-text-field
        v-bind="$attrs"
        v-on="$listeners"
        :value="value"
        :append-icon="value ? (isVisiblePassword ? 'mdi-eye-off' : 'mdi-eye') : ''"
        :type="isVisiblePassword ? 'text' : 'password'"
        @click:append="isVisiblePassword = !isVisiblePassword"
        autocomplete="off"
        label="Пароль"
        :class="[$vnode.data.class, $vnode.data.staticClass]"
    ></v-text-field>
</template>

<style scoped lang="scss">

</style>
